export default "__VITE_ASSET__6637ec82__"